<template>
  <div class="date-range-select">
    <span class="text-content">{{ title }}：</span>
    <!-- 时间选择-按钮 -->
    <span v-if="!range">
      <span
        class="date-btn"
        @click="showPicker"
      >{{ defaultDate && defaultDate.text }}<i class=" margin-left-4 iconfont iconicon-test17" />
      </span>
      <!-- <span class="time-text">{{ timeText }}</span> -->
    </span>
    <!-- 来源选择-按钮 -->
    <span
      v-if="fromOrigin"
      class="date-btn"
      style="margin-top: 2px !important; height:28px; display: inline-block;"
      @click="handleMessageSelect"
    ><em>{{ fromOriginText }}</em><i class=" margin-left-4 iconfont iconicon-test17" />
    </span>
    <!-- 数据模块-人员选择-按钮 -->
    <span
      v-if="group&&groupname"
      class="date-btn"
      @click="handleTeamSelect"
    >{{ teamselectText }}
      <i
        v-if="teamLists.length"
        class=" margin-left-4 iconfont iconicon-test17"
      />
    </span>
    <!-- 人员-范围选择-按钮-->
    <span
      v-if="range"
      class="date-btn range-select"
      @click="handleMembersSelect"
    >{{ memberSelectedText }}<i class=" margin-left-4 iconfont iconicon-test17" />
    </span>
    <span
      v-if="showTypeSelect"
      class="date-btn range-select types"
      @click="handleTypeSelect"
    >{{ typeSelectedText }} <i class=" margin-left-4 iconfont iconicon-test17" />
    </span>
    <!-- 人员-范围选择-弹窗 -->
    <Members
      :source-datas="memberRangeDatas"
      separator="/"
      :visible.sync="visible"
      @change="handleChange"
    />
    <!-- 来源选择-弹窗 -->
    <Members
      :source-datas="localmessageList"
      :default-value="defaultValue"
      separator="/"
      is-must-last
      :visible.sync="visibledis"
      @change="handleChangedis"
    />
    <!-- 时间选择（今日/本周/本月/本年）-弹窗 -->
    <TimeSelect
      :visible.sync="timeVisible"
      @timeSelectChange="handleTimeSelectChange"
    />
    <!-- 团队选择-弹窗 -->
    <TeamSelect
      :visible.sync="teamvisible"
      :team-lists="teamLists"
      @teamselect="handleSeamselect"
    />
    <!-- 类型选择（有效/无效等）-弹窗 -->
    <type-select
      :visible.sync="typeVisible"
      :team-lists="teamLists"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { getDateText } from '@/lib/statistic-utils'
import Members from '@/components/mobile/Members'
import TimeSelect from './TimeRangeComponents'
import TeamSelect from './TeamSelect'
import TypeSelect from './TypeSelect'
export default {
  components: {
    Members,
    TimeSelect,
    TeamSelect,
    TypeSelect
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    groupname: {
      type: String,
      default: ''
    },
    fromOrigin: {
      type: Boolean,
      defaule: false
    },
    level: {
      type: Boolean,
      defaule: false
    },
    group: {
      type: Boolean,
      defaule: false
    },
    range: {
      type: Boolean,
      defaule: false
    },
    dateData: {
      type: Array,
      default: () => ([])
    },
    teamLists: {
      type: Array,
      default: () => ([])
    },
    // 是否显示数据类型选择
    showTypeSelect: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      teamvisible: false,
      timeVisible: false,
      defaultValue: [],
      localDateSelect: [],
      visible: false,
      localmessageList: [],
      visibledis: false,
      memberSelectedText: '',
      teamselectText: '',
      fromOriginText: this.$t('message["906"]'),
      isFromSelect: false,
      defaultDate: {
        text: '',
        value: null
      },
      // 类型选择弹框
      typeVisible: false,
      typeSelectedText: this.$t('message["907"]'),
      typeSelectedIndex: [0]
    }
  },
  computed: {
    ...mapState('statistic', [
      'memberRangeDatas',
      'memberRangeDefaultDatas',
      'messageSourceList',
      'customTimeRange',
      'staticType'
    ])
  },
  watch: {
    range: {
      handler (val) {
        if (val) {
          this.setMemberText()
        }
      },
      immediate: true
    },
    groupname (val) {
      console.log('ok:' + val)
      if (!val) return
      this.teamselectText = val
    },
    // 信息来源数据
    messageSourceList: {
      handler (val) {
        if (!val) return
        if (Array.isArray(val)) {
          val.map(value => {
            if (value.child) {
              for (const key in value.child) {
                if (value.child[key].options) {
                  delete value.child[key].options
                }
              }
            }
          })
          if (val.length > 0) {
            this.localmessageList = val
          }
        }
      },
      immediate: true
    }
    /* type: {
      handler (val) {
        // if (val === 'dev') {
        //   this.fetchGetMemberRangeDatas()
        // } else if (val === 'rec') {
        //   this.fetchGetMemberRecRangeDatas()
        // } else if (val === 'follow') {
        //   this.fetchGetMemberFollowRangeDatas()
        // }
      },
      immediate: true
    } */
  },
  mounted () {
    if (this.dateData) {
      this.defaultDate = this.dateData[0]
    }
    if (this.fromOrigin) {
      this.fetchGetMessageSource()
    }
    // 信息开发/信息接待
    this.showTypeSelect && this.fetchStaticTypes()
    this.teamselectText = this.groupname
  },
  methods: {
    ...mapActions('statistic', [
      'fetchGetMemberRangeDatas',
      'fetchGetMemberRecRangeDatas',
      'fetchGetMemberFollowRangeDatas',
      'fetchGetMessageSource',
      'fetchStaticTypes'
    ]),
    ...mapMutations('statistic', ['setMemberRangeDefaultDatas']),
    // 设置范围-人员选择值为接口返回的默认值
    setMemberText () {
      if (this.memberRangeDefaultDatas && this.memberRangeDatas) {
        const [value] = this.memberRangeDefaultDatas
        if (value.indexOf('-') < 0) return
        const [name, key] = value.split('-')
        let text = ''
        this.memberRangeDatas.some(values => {
          if (values.id * 1 === key * 1 && values.keyname === name) {
            text = values.name
            return true
          }
        })
        this.memberSelectedText = text
      }
    },
    handleMembersSelect () {
      this.visible = true
    },
    handleMessageSelect () {
      this.visibledis = true
    },
    handleTeamSelect () {
      if (this.teamLists.length) {
        this.teamvisible = true
      }
    },
    handleSeamselect (value) {
      this.teamselectText = value.name
      this.$emit('teamSelectFollow', value.value)
    },
    /* 范围-人员选择 */
    handleChange (value) {
      this.visible = false
      this.memberSelectedText = value.text
      this.$emit('memberChange', { text: this.memberSelectedText, value: value.value })

      let arr = value.value.map(item => item.keyname + '-' + item.id)
      this.setMemberRangeDefaultDatas(arr)
    },
    handleChangedis (value) {
      this.visibledis = false
      this.fromOriginText = value.text
      this.$emit('messageChange', { text: this.fromOriginText, value: value.value })
    },
    formateFromDatas (array) {
      const tempv = []
      if (Array.isArray(array)) {
        array.map(value => {
          let json = {
            value: value.fieldkey,
            text: value.fieldname,
            children: []
          }
          if (value.child) {
            for (const key in value.child) {
              json.children.push({
                value: value.child[key].fieldkey,
                text: value.child[key].fieldname,
                children: []
              })
            }
          }
          tempv.push(json)
        })
      }
      tempv.unshift({
        value: -1,
        text: this.$t('message["909"]'),
        children: []
      })
      return tempv
    },
    addUDDate (array) {
      if (array[array.length - 1]) {
        if (array[array.length - 1].value !== -1) {
          array.push({
            text: this.$t('message["1660"]'),
            value: -1
          })
        }
      }
      return array
    },
    // 显示select选择
    showPicker () {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: this.$t('message["855"]'),
          data: [this.addUDDate(this.dateData)],
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    // 时间选择结果回调
    // 时间选择弹窗，点击确定按钮
    selectHandle (selectedVal, selectedIndex, selectedText) {
      const [value] = selectedVal
      this.defaultDate = getDateText(this.dateData, value)
      if (value === -1) {
        this.timeVisible = true
      } else {
        this.$emit('dateCallback', { value })
      }
    },
    handleTimeSelectChange (value) {
      this.$emit('dateCallback', { value: -1, time: value })
    },
    // 取消选择
    cancelHandle () {
    },
    // 类型选择
    handleTypeSelect () {
      if (!this.typePicker) {
        this.typePicker = this.$createPicker({
          title: this.$t('message["855"]'),
          selectedIndex: this.typeSelectedIndex,
          data: [this.staticType.map(item => {
            return { text: item.name, value: item.id }
          })],
          onSelect: this.typeSelectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.typePicker.show()
    },
    typeSelectHandle (selectedVal, selectedIndex, selectedText) {
      const [value] = selectedVal
      const [text] = selectedText
      this.typeSelectedText = text
      this.typeSelectedIndex = selectedIndex
      this.$emit('typeCallback', { value })
    }
  }
}
</script>
<style lang="scss" scoped>
.date-range-select::v-deep {
  position: relative;
  width: 375px;
  height: 50px;
  background-color: #fff;
  margin: 0;
  border-bottom: solid 1px rgba(219, 219, 219, 1);
  .text-content {
    height: 48px;
    line-height: 48px;
    margin-left: 12px;
  }
  .time-text {
    margin-left: 12px;
    font-size: 12px;
  }
  .date-btn {
    padding: 4px 6px 4px 8px;
    height: 14px;
    background: rgba(80, 119, 170, 1);
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    vertical-align: middle;
    cursor: pointer;
    margin-top: -2px;
    margin-left: 8px;
    &:first-child {
      margin-left: 0px;
    }
    em {
      max-width: 120px;
      height: 20px;
      line-height: 20px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
      font-style: normal;
      vertical-align: middle;
    }
  }
  .range-select {
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space: nowrap;
  }
  .types {
    float: right;
    height: 26px;
    margin: 12px;
    padding: 4px 6px 4px 8px;
  }
}
</style>
